import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const PepYesNoToggle = ({ value, onChange }) => (
  <div className="corp-step-form__pep-tabs">
    {[
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' }
    ].map((opt) => (
      <button
        key={opt.value}
        type="button"
        className={classNames('corp-step-form__pep-tab', {
          'corp-step-form__pep-tab--selected': value === opt.value
        })}
        onClick={() => onChange(opt.value)}>
        <span className="corp-step-form__pep-tab-radio">
          {value === opt.value && <span className="corp-step-form__pep-tab-radio-dot" />}
        </span>
        {opt.label}
      </button>
    ))}
  </div>
);

PepYesNoToggle.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export { PepYesNoToggle };
